import { DeprecatedThemeOptions } from '@mui/material/styles';

const defaultFontFamily = [
  'Roboto',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');

export const typography: DeprecatedThemeOptions['typography'] = {
  fontFamily: defaultFontFamily,
  fontSize: 14,
  h1: {
    fontFamily: 'Poppins',
    fontSize: '96px',
    fontWeight: 300,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontFamily: 'Poppins',
    fontSize: '60px',
    fontWeight: 300,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontFamily: 'Poppins',
    fontSize: '48px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
  },
  h4: {
    fontFamily: 'Poppins',
    fontSize: '34px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '0.25px',
  },
  h5: {
    fontFamily: 'Poppins',
    fontSize: '24px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
  },
  h6: {
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
  body1: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.56,
    letterSpacing: '0.5px',
  },
  body2: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '0.25px',
  },
  subtitle1: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '0.25px',
  },
  subtitle2: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: '0.15px',
  },
  button: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: '0.8px',
  },
  caption: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'italic',
    lineHeight: 1.33,
    letterSpacing: '0.4px',
  },
  overline: {
    fontFamily: 'Poppins !important',
    fontSize: '10px !important',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.6 !important',
    letterSpacing: '0.8px !important',
  },
};
